import { render, staticRenderFns } from "./ReserveSetGroupEditInfo.vue?vue&type=template&id=be4940f2&"
import script from "./ReserveSetGroupEditInfo.vue?vue&type=script&lang=ts&"
export * from "./ReserveSetGroupEditInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ReserveSetGroupEditInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports